/* Utility functions for pages */
import cookieMgr from 'js-cookie';

/**
 * Utility function to generate top-of-page links from the configured sections.
 * Any section configured with a "linkto" field will be included.
 * @param object - the site configuration object
 * @return object array
 */
function makeSectionLinks(config) {
  if (!(config && config.hasOwnProperty('sections') && Array.isArray(config.sections))) return null;
  // Note: links are not relative but point to root ("/")
  return config.sections.filter(sec => Boolean(sec.linkto)).map(sec => ({label:sec.title , to:`/${sec.linkto}`}));
}

/**
 * Utility function to generate links from one or more objects.
 * Links will not be relative but point to root, having a "/" prepended to it.
 * @param array - an array of objects of the form "{title, linkto}"
 * @return object array
 */
function makeTopLinks(links) {
  if (!Array.isArray(links)) return null;
  return links.map(link => ({label:link.title , to:`/${link.linkto}`}));
}

/**
 * Sets container element heights which is needed with variable height child elements
 * (that are absolutely positioned -- as is the case with slide transitions).
 */
function adjustSlideHeight() {
  const activeSlide = document.querySelector('.slide.slide-active');
  if (!activeSlide) {
    console.error('Unable to find active slide (selector=".slide.slide-active")');
    return;
  }
  const container = activeSlide.closest('.screener-section');
  const screener = activeSlide.closest('.screener');
  const newHeight = `${activeSlide.clientHeight}px`;
  screener.style.height = newHeight;
  container.style.height = newHeight;
}

/**
 * Return an event handler function that calls a specified function on ENTER keypress.
 * @param function
 * @return function
 */
function filterKeyEnter(handler) {
  return function(e) { if (e.keyCode===13) { handler(e); } };
}

/**
 * Add a script to the document body.
 * @param string - an element id
 * @param string - the path of the script
 */
function addScript(id, path) {
  const scriptTag = document.createElement('script');
  scriptTag.id = id;
  scriptTag.src = path;
  document.body.appendChild(scriptTag);
}

/**
 * Subtract a given set of attributes from an object.
 * @param object - the source object
 * @param array - a list of attribute names as strings
 * @return object
 */
function removeFields(srcObject, fieldlist) {
  return Object.keys(srcObject).filter(attrib => !fieldlist.includes(attrib)).reduce((root, attrib) => {
    root[attrib] = srcObject[attrib];
    return root;
    }, {});
}

function getCookie(name) { return cookieMgr.get(name); }

function css(base, optional) { if (optional) return `${base} ${optional}`; else return base; }

/**
 * Collect parameter objects for dropdown fields from configuration values.
 * @param object - configuration object for form fields
 * @return function - gets the object at the top of the stack
 */
function initDropdowns(patientFields, fieldNames) {
  const config = fieldNames.reduce((fields, key) => {
    if (patientFields[key]) {
      fields.push({
        name: key,
        defaultvalue: patientFields[`${key}Default`],
        items: patientFields[key]
      });
    }
    return fields;
  }, []);
  return {
    pop: function() { return (config.length>0 ? config.shift() : null); },
    get: function(name) { return config.find(item => item.name===name); }
  };
}

export { makeSectionLinks, makeTopLinks, adjustSlideHeight, addScript, removeFields, getCookie, css, initDropdowns };
